import {
  Agendamiento,
  City,
  Cliente,
  Country,
  Empresa,
  EntidadesFinancieras,
  EstadoContrato,
  Flota,
  IDataPreventa,
  IDataProspecto,
  IPaymentMethod,
  IPreagendamiento,
  IPromocion,
  MotivoRechazo,
  Naps,
  Nodo,
  OLT,
  OrdenTrabajo,
  Plan,
  Province,
  Router,
  Sector,
  Tarjeta,
  TipoInstalacion,
  Vendedor,
  Zone,
} from '..';
import { Documentacion } from '../documentos/Documentacion';

export interface ContratosPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: Contrato[];
}

export interface UrlAnexoNombreUrl {
  url: string;
  nombre: string;
}

// // Contrato new interface
export interface Contrato {
  id_contrato?: string;
  tag?: string;
  tipo_contrato: string;
  tipo_plan: string;
  tipo_servicio: string;
  velocidad: string;
  valor_plan: string;
  valor_instalacion: string;
  valor_plan_descuento: string;
  valor_plan_iva: string;
  valor_instalacion_descuento: string;
  valor_instalacion_iva: string;
  valor_plan_total: string;
  valor_instalacion_total: string;
  coordenadas: string;

  ip_publica?: string | null;
  ipv4_actual?: string | null;
  ipv6_actual?: string | null;
  ipv4_anterior?: string | null;
  ipv6_anterior?: string | null;
  es_router_ac: boolean;
  pppoe?: string;
  pppassword?: string | null;
  puerto?: string | null;

  url_contrato: string;
  linea: number;

  numero_cuenta: string;
  numero_tarjeta: string;
  tipo_cuenta_bancaria: string;
  tipo_equipo: string;
  tipo_referido: string;

  estado_contrato: string; // choice
  estado_actualizacion?: string;
  motivo_rechazo?: any;
  estado_navegacion?: EstadosNavegacionEnum;

  estado: boolean;
  codigo: string;
  numero_referencia?: string;

  fecha_creacion?: string;
  fecha_modificacion?: string;

  persona_referencia_parentesco?: string,
  persona_referencia_nombre?: string,
  persona_referencia_celular?: string,
  persona_referencia_celular_2?: string,

  observaciones: {
    observacion_update_cliente?: string;
    observacion_asesor?: string;
    fecha_aceptacion?: string;
    tiempo_permanencia?: string;
  } | null
  ///* fk -------------
  cliente?: string | null;
  forma_pago?: string | null;
  plan?: string | null;
  tipo_instalacion?: string | null;
  nap?: string | null;
  olt?: string | null;
  nodo?: string | null;
  router?: string | null;
  bras?: string | null;
  es_bras?: boolean;
  caja_primaria?: string | null;
  entidad_financiera?: string | null;
  tarjeta?: string | null;
  referido_flota?: string | null;
  referido_cliente?: string | null;

  promociones: IPromocion[];

  // cliente --
  pais?: string;
  provincia?: string;
  ciudad?: string;
  parroquia?: string | null;
  zona?: string;
  sector?: string;
  edad?: number;
  celular: string;
  celular_2: string;
  email: string;
  direccion: string;
  estado_equipo: string; // choice: EstadosEquipoChoiceEnum

  // anexos
  url_anexo_1?: string;
  url_anexo_2?: string;
  url_crokis?: string;
  url_orden_trabajo?: string;

  url_anexo_1_f?: string;
  url_anexo_1_orden?: string;
  url_anexo_1_tec?: string;
  url_anexo_2_f?: string;
  url_anexo_2_orden?: string;
  url_anexo_2_tec?: string;
  url_anexo_2_pymes?: UrlAnexoNombreUrl[];

  url_autorizacion_buro?: string;
  url_solicitud_beneficio?: string;
  url_anexo_3_f?: string;

  // filtering ventas
  user_create?: string;
  empresa_create?: string;
  area_create?: string;
  departamento_create?: string;
  canal_venta_create?: string;
  user_revisa?: string;
  observaciones_contrato?: {
    [key: string]: any;
    contenido: ContenidoItem[];
  };
  correccion_para?: string;
  user_revisa_razon_social?: string;
  user_revisa_username?: string;

  //filtros
  vendedor?: string;
  supervisor?: string;



  prospecto_data?: IDataProspecto
  motivo_rechazo_data: MotivoRechazo | null
  user_create_data?: {
    username?: string;
    razon_social?: string;
    departamento?: string;
  };
  canal_venta_data?: {
    nombre?: string;
  };
  departamento_data?: {
    nombre?: string;
  };
  departamento_supervisor_data?: {
    nombre?: string;
  };
  cliente_data?: Cliente;
  forma_pago_data?: IPaymentMethod;
  plan_data?: Plan;
  tipo_instalacion_data?: TipoInstalacion;
  nap_data?: Naps;
  olt_data?: OLT;
  nodo_data?: Nodo;
  router_data?: Router;
  entidad_financiera_data?: EntidadesFinancieras;
  tarjeta_data?: Tarjeta;
  referido_flota_data?: Flota;
  referido_cliente_data?: Cliente;
  //FILTROS TECNICOS
  serie_ont?: string;
  ip?: string;
  fmax?: string;

  pais_data?: Country;
  provincia_data?: Province;
  ciudad_data?: City;
  parroquia_data?: null;
  zona_data?: Zone;
  sector_data?: Sector;

  // helper serializer
  flota_data?: Flota;
  preventa_data?: Omit<IDataPreventa, "contrato_data" | "contrato">;
  preagendamiento_data?: Omit<IPreagendamiento, "contrato_data" | "contrato">;
  agendamiento_data?: Omit<Agendamiento, "contrato_data" | "contrato">;
  orden_trabajo_data?: Omit<OrdenTrabajo, "contrato_data" | "contrato">;
  promociones_data?: IPromocion[];
  empresa_create_data?: Empresa;

  //additionals
  supervisor_data?: any;
  vendedor_data?: Vendedor;
  id_instalacion?: string

  documentacion_data?: Documentacion[] | null
  tiempo_contrato?: number;
  ssid?: string;
  password_wifi?: string;

  fecha_hora_instalacion?: string;
  es_migracion_tecnologia?: boolean;
  fecha_migracion_tecnologia?: string;
}
interface ContenidoItem {
  motivos: string[];
  observaciones?: string;
  observaciones_tecnico?: string;
  observaciones_ventas?: string;
  ultimos_motivos_correccion?: string;
  fecha: Date;
}

export type SimpleContrato = {
  numero_referencia: string;
  fecha_inicio: string;
  duracion: number;
  id_contrato: string;
  estado: EstadoContrato;
};


export enum EstadosActualizacionContratoEnum {
  // PENDIENTE ='PENDIENTE',
  ACTUALIZADO = 'ACTUALIZADO',
  REVISADO = 'REVISADO',

  RECHAZADO = 'RECHAZADO',
  PENDIENTE_REVISION = 'PENDIENTE REVISION',
  SOLICITUD_CORRECCION = 'SOLICITUD CORRECCION',
  CORREGIDO = 'CORREGIDO',
  APROBADO = 'APROBADO',

  ALL = 'VER TODOS',
}

export enum EstadosActualizacionCompatibilityContratoEnum {
  PENDIENTE_REVISION = 'PENDIENTE REVISIÓN',
  APROBADO = 'APROBADO',
}



export const ESTADOS_INFO_CONTRATO_CHOICE: EstadosActualizacionContratoEnum[] = [
  // EstadosActualizacionContratoEnum.RECHAZADO,
  EstadosActualizacionContratoEnum.PENDIENTE_REVISION,
  EstadosActualizacionContratoEnum.SOLICITUD_CORRECCION,
  EstadosActualizacionContratoEnum.CORREGIDO,
  // EstadosActualizacionContratoEnum.APROBADO,

  // helper state not included in db
  EstadosActualizacionContratoEnum.ALL,
];

export interface IContratoSimple extends Omit<Contrato,
  'orden_trabajo_data'
  | 'agendamiento_data'
  | 'preagendamiento_data'
  | 'preventa_data'
  | 'cliente_data'> {

}

export enum EstadosNavegacionEnum {
  EN_ESPERA = "EN ESPERA",
  ACTIVO = "ACTIVO",
  AUDITADO = "AUDITADO",
  DESCONECTADO = "DESCONECTADO",
  SUSPENDIDO = "SUSPENDIDO",
  REACTIVADO = "REACTIVADO",//NO DEBEN EXISTIR REGISTROS CON ESTE ESTADO, SOLO ACTIVO Y SUSPENDIDO
}
